import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { PrivacyPolicyResponse } from "../../pages/PrivacyPolicy/schema/privacyPolicy.schema";

import { privacyPolicyApi } from "./privacyPolicy.api";

interface PrivacyPolicyState {
	privacyPolicy: PrivacyPolicyResponse | null;
}

const initialState: PrivacyPolicyState = {
	privacyPolicy: null,
};

export const privacyPolicySlice = createSlice({
	name: "privacyPolicy",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			privacyPolicyApi.endpoints.fetchPrivacyPolicy.matchFulfilled,
			(state, { payload }) => {
				state.privacyPolicy = payload;
			}
		);
	},
});

export const privacyPolicyReducer = privacyPolicySlice.reducer;
export const privacyPolicySelector = (state: RootState) => state[privacyPolicySlice.name];
